/**
 * Proposte in attesa, sempre a portata di tap (§1.ter, P1).
 *
 * Se c'è qualcosa che aspetta una decisione, non deve restare sepolto in una
 * conversazione di ieri: una striscia sottile sopra l'input lo riporta a galla,
 * in qualsiasi punto dell'app ci si trovi.
 */

import { useState } from "react";
import { ChevronRight, Clock } from "lucide-react";
import { useStore } from "../lib/store.tsx";
import { Sheet } from "../ui/Sheet.tsx";
import { ProposalCard } from "../blocks/ProposalCard.tsx";
import { cx } from "../ui/primitives.tsx";

export function PendingBanner() {
  const store = useStore();
  const [open, setOpen] = useState(false);

  const pending = [...store.actions.values()].filter(
    (action) => action.status === "proposta",
  );
  if (pending.length === 0) return null;

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={cx(
          "flex w-full items-center gap-2.5 rounded-pill bg-accent-soft px-3.5 py-2.5 text-left",
          "ring-1 ring-accent-line transition-all duration-quick hover:bg-accent-soft/70 active:scale-[0.99]",
        )}
      >
        <Clock size={15} className="shrink-0 text-accent" />
        <span className="flex-1 text-[13px] font-semibold text-ink">
          {pending.length === 1
            ? "1 proposta aspetta la tua conferma"
            : `${pending.length} proposte aspettano la tua conferma`}
        </span>
        <ChevronRight size={15} className="shrink-0 text-ink-faint" />
      </button>

      <Sheet open={open} onClose={() => setOpen(false)} title="Da confermare">
        <div className="flex flex-col gap-3 pt-1">
          {pending.map((action) => (
            <ProposalCard
              key={action.id}
              actionId={action.id}
              fallback={action.preview}
            />
          ))}
        </div>
      </Sheet>
    </>
  );
}
